module.exports = __webpack_public_path__ + "img/JCB_200x120.3cc30e09.jpg";